import UsersTab from "@features/security/components/UsersTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Users } from "lucide-react";

export const Route = createFileRoute("/_app/admin/")({
  loader: requirePermission(PERMISSIONS.SECURITY.USERS.VIEW),
  staticData: {
    title: "Utilisateurs",
    icon: Users,
    permission: PERMISSIONS.SECURITY.USERS.VIEW,
    module: "security",
    section: "Administration",
    order: 10,
    showInTab: true,
  },
  component: UsersTab,
});
